var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.89,
    height: 20.105,
    viewBox: "0 0 16.89 20.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield-tick",
    d: "M18.541,4.12l-5.5-2.06a3.479,3.479,0,0,0-2.07,0l-5.5,2.06a3.183,3.183,0,0,0-1.92,2.77v8.1a3.32,3.32,0,0,0,1.18,2.36l5.5,4.11a3.119,3.119,0,0,0,3.53,0l5.5-4.11a3.339,3.339,0,0,0,1.18-2.36V6.89A3.163,3.163,0,0,0,18.541,4.12Zm-3.06,5.6-4.3,4.3a.748.748,0,0,1-1.06,0l-1.6-1.62a.75.75,0,0,1,1.06-1.06l1.08,1.08,3.77-3.77a.75.75,0,1,1,1.05,1.07Z",
    transform: "translate(-3.551 -1.902)",
    fill: "#f3903a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.ba57bed8587e93361a57d85c02de4c10.svg";
export { ForwardRef as ReactComponent };